import { PaletteMode } from "@mui/material";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../store";

export interface IThemeModeState {
  value: PaletteMode;
}

const initialState: IThemeModeState = {
  value: "light",
};

export const themeModeSlice = createSlice({
  name: "themeMode",
  initialState,
  reducers: {
    setThemeMode: (state, action: PayloadAction<IThemeModeState>) => {
      state.value = action.payload.value;
    },
    switchMode: (state) => {
      state.value = state.value === "dark" ? "light" : "dark";
    },
  },
});

export const { setThemeMode, switchMode } = themeModeSlice.actions;

export const selectThemeMode = (state: RootState) => state.themeMode.value;

export default themeModeSlice.reducer;
